// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pwt-full-img-logo[data-v-68f4c0d4]{width:100px;height:auto}.pwt-circular-logo-img-wrapper[data-v-68f4c0d4]{overflow:hidden;width:24px;height:24px;border-radius:50%;margin-right:5px}.pwt-circular-logo-img[data-v-68f4c0d4]{width:24px;height:24px}.pwt-img-and-text-logo-wrapper[data-v-68f4c0d4]{display:flex;flex-direction:row;align-items:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
